import { combineReducers } from 'redux';
import logginReducer from './logginReducer';
import tournamentReducer from './tournamentReducer';
import streamReducer from './streamReducer';
import isLoadingReducer from './isLoadingReducer';

const reducers = combineReducers({
        user: logginReducer,
        stream: streamReducer,
        rounds: tournamentReducer,
        isLoading: isLoadingReducer,
});

export default reducers;